{
  "WALLBOARD": {
    "LOADING": "Įkeliamos skambučių eilės...",
    "NO_QUEUES": "Skambučių eilių nerasta.",
    "NO_AGENTS": "Šioje eilėje nėra prisijungusių agentų.",
    "UNKNOWN_CALLER": "Nežinomas skambinantysis",
    "STATUS": "Būsena",
    "TIME": "Laikas",
    "AGENT": "Agentas",
    "EXTENSION": "Vidinis numeris",
    "READY": "Pasiruošę agentai",
    "ON_CALL": "Agentai skambutyje",
    "PAUSED": "Agentai pertraukoje",
    "WAITING": "Laukiantys skambučiai",
    "MISSED_CALLS": "Praleisti skambučiai",
    "HANDLED_CALLS": "Apdoroti įeinantys skambučiai",
    "OUTBOUND_CALLS": "Apdoroti išeinantys skambučiai",
    "AVAILABILITY": "Prieinamumas",
    "AVAILABILITY_TOOLTIP": "Įeinančių skambučių, į kuriuos atsiliepė agentai, procentinė dalis (pakelti skambučiai)",
    "AGENTS_COUNT": "({onCall} skambutyje / {total} iš viso)",
    "NO_AVAILABLE": "(niekas neprisijungęs)",
    "WAITING_CALLERS_COUNT": "{count} laukia",
    "CALLER": "Skambinantysis",
    "NUMBER": "Numeris",
    "WAIT_TIME": "Laukimo laikas",
    "ACTION": "Veiksmas",
    "PICKUP_CALL": "Atsiliepti",
    "PICKUP_SUCCESS": "Prašymas atsiliepti į skambutį išsiųstas sėkmingai.",
    "PICKUP_ERROR": "Nepavyko atsiliepti į skambutį. Bandykite dar kartą.",
    "PICKUP_DISABLED_TOOLTIP": "Negalite atsiliepti į skambutį, kai kalbate arba esate atsijungę.",
    "CHAT_STATUS": {
      "NO_ACCESS": "Nėra prieigos"
    },
    "PHONE_STATUS": {
      "NO_ACCESS": "Nėra prieigos"
    }
  }
}
